import { render } from "./DataQuality.vue?vue&type=template&id=323bf2b2&ts=true"
import script from "./DataQuality.vue?vue&type=script&lang=ts"
export * from "./DataQuality.vue?vue&type=script&lang=ts"

import "./DataQuality.vue?vue&type=style&index=0&id=323bf2b2&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__